import { ReportResponseResource } from "@models/resource/report-response.resource";
import { CollectionSummaryState, CollectionSummaryData } from "@models/ui/case-analytics-state/collection-summary-state.model";
import { MapperBase } from "@utilities/mapper-base";

export class ReportResponseResourceToCollectionSummaryStateMapper extends MapperBase<ReportResponseResource, CollectionSummaryState> {
    map(source: ReportResponseResource): CollectionSummaryState {
        const dest = new CollectionSummaryState();
        const uniqueCustodianNames = new Set<string>();
        dest.summaryData = [];
        source?.data.forEach((item) => {
            const existingPeriod = dest.summaryData.find(summary => summary.period === item.date);
            uniqueCustodianNames.add(item.custodian);
            if (existingPeriod) {
                existingPeriod.custodianData.push({
                    name: item.custodian,
                    count: Number(item.docCount)
                });
            } else {
                const periodSummaryData = new CollectionSummaryData();
                periodSummaryData.period = item.date;
                periodSummaryData.custodianData = [{
                    name: item.custodian,
                    count: Number(item.docCount)
                }];

                dest.summaryData.push(periodSummaryData);
            }
        });
        dest.custodians = Array.from(uniqueCustodianNames.keys());
        dest.summaryData = dest.summaryData.filter((x) => x.period !== 'Total');
        return dest;
    }
}